import { render, staticRenderFns } from "./Lgx02734365083422806770138.vue?vue&type=template&id=124493b4&"
import script from "./Lgx02734365083422806770138.vue?vue&type=script&lang=js&"
export * from "./Lgx02734365083422806770138.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02734365083422806770138.vue?vue&type=style&index=0&id=124493b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports